function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import * as Updates from "expo-updates";
import { Platform } from "react-native";
export function checkForUpdateAsync() {
    return _checkForUpdateAsync.apply(this, arguments);
}
function _checkForUpdateAsync() {
    _checkForUpdateAsync = _async_to_generator(function() {
        var _result_match, _Array_from_find_src_match, _Array_from_find, result, nextVersion, currentVersion, isAvailable;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(Platform.OS === 'web')) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        fetch(window.location.origin).then(function(r) {
                            return r.text();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    nextVersion = result === null || result === void 0 ? void 0 : (_result_match = result.match(/app\.([0-9a-z]*)\.chunk\.js/)) === null || _result_match === void 0 ? void 0 : _result_match[1];
                    currentVersion = (_Array_from_find = Array.from(document.querySelectorAll('script')).find(function(s) {
                        return s.src.match(/app\.([0-9a-z]*)\.chunk\.js/);
                    })) === null || _Array_from_find === void 0 ? void 0 : (_Array_from_find_src_match = _Array_from_find.src.match(/app\.([0-9a-z]*)\.chunk\.js/)) === null || _Array_from_find_src_match === void 0 ? void 0 : _Array_from_find_src_match[1];
                    isAvailable = !!(nextVersion && nextVersion !== currentVersion);
                    return [
                        2,
                        isAvailable ? {
                            isAvailable: isAvailable,
                            manifest: {}
                        } : {
                            isAvailable: isAvailable
                        }
                    ];
                case 2:
                    return [
                        2,
                        Updates.checkForUpdateAsync().catch(function(e) {
                            var ignoredErrors = [
                                'ERR_UPDATES_DISABLED',
                                'EXPERIENCE_NOT_FOUND'
                            ];
                            if (ignoredErrors.includes(e.code) || ignoredErrors.includes(e.errorCode)) {
                                return {
                                    isAvailable: false
                                };
                            }
                            throw e;
                        })
                    ];
            }
        });
    });
    return _checkForUpdateAsync.apply(this, arguments);
}
export function fetchUpdateAsync() {
    return _fetchUpdateAsync.apply(this, arguments);
}
function _fetchUpdateAsync() {
    _fetchUpdateAsync = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (Platform.OS === 'web') {
                return [
                    2,
                    Promise.resolve()
                ];
            }
            return [
                2,
                Updates.fetchUpdateAsync()
            ];
        });
    });
    return _fetchUpdateAsync.apply(this, arguments);
}
export function reloadAsync() {
    return _reloadAsync.apply(this, arguments);
}
function _reloadAsync() {
    _reloadAsync = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (Platform.OS === 'web') {
                return [
                    2,
                    global.window.location.reload()
                ];
            }
            return [
                2,
                Updates.reloadAsync()
            ];
        });
    });
    return _reloadAsync.apply(this, arguments);
}
